import React, { useMemo } from 'react';
import styles from '../style.module.css';
import { Divider, Stack, Typography } from '@mui/material';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';

export const EventNode = React.memo(({ id, data }) => {
  const { nodes } = useAccomodationDiagram();

  const { freeBeds, takenBeds } = useMemo(() => {
    const childNodes = nodes.filter(n => n.parentId === id);

    return {
      freeBeds: childNodes.length,
      takenBeds: childNodes.filter(n => n.data.order).length
    };
  }, [nodes, id]);

  return (
    <div className={styles.eventNode}>
      <Stack direction="row" justifyContent="center">
        {data?.prefix && <Typography align="center" fontSize="8px"><b>{data.prefix} - &nbsp;</b></Typography>}
        <Typography align="center" fontSize="10px">{data?.eventGroup?.name}</Typography>
        <Typography color={takenBeds === freeBeds ? 'error' : 'primary'} align="center" fontSize="8px">
          &nbsp;{`(${takenBeds}/${freeBeds})`}
        </Typography>
      </Stack>
      <Divider />
    </div>
  );
}, (prevProps, nextProps) => prevProps.data.prefix === nextProps.data.prefix &&
  prevProps.data.eventGroup?.name === nextProps.data.eventGroup?.name &&
  prevProps.id === nextProps.id
);

export default EventNode;
